module.exports = __webpack_public_path__ + "img/fwt_icon.946764cd.png";